// extracted by mini-css-extract-plugin
export var chip = "_cz-0";
export var filterDropdown = "_cz-5";
export var filterItem = "_cz-6";
export var icon = "_cz-1";
export var removeButton = "_cz-3";
export var removeIcon = "_cz-4";
export var separator = "_cz-2";